var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[(!_vm.videoInText)?_c('Base',{style:([_vm.styles])},[_c('div',{staticClass:"video-wrapper",class:{ wrapper: _vm.data.video.size !== 'full_bleed' && !_vm.videoInText }},[_c('Vid',{attrs:{"layout":_vm.layout,"data":_vm.data.video}})],1)]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }